var _rect, _rect2, _g, _rect3, _rect4, _g2, _rect5, _rect6, _g3, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUploadPlaceholder(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 98,
    height: 63,
    viewBox: "0 0 98 63",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 19.5,
    y: 1,
    width: 61,
    height: 61,
    rx: 30.5,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 19.5,
    y: 1,
    width: 61,
    height: 61,
    rx: 30.5,
    stroke: "#E9E9E9",
    strokeDasharray: "2 2"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5198_35307)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M56.4312 29.785C55.8363 26.7662 53.185 24.5 50 24.5C47.4713 24.5 45.275 25.935 44.1813 28.035C41.5475 28.315 39.5 30.5462 39.5 33.25C39.5 36.1462 41.8537 38.5 44.75 38.5H56.125C58.54 38.5 60.5 36.54 60.5 34.125C60.5 31.815 58.7063 29.9425 56.4312 29.785ZM56.125 36.75H44.75C42.8162 36.75 41.25 35.1838 41.25 33.25C41.25 31.4563 42.5887 29.96 44.365 29.7762L45.3012 29.68L45.7387 28.8488C46.57 27.2475 48.1975 26.25 50 26.25C52.2925 26.25 54.27 27.8775 54.7162 30.1263L54.9788 31.4388L56.3175 31.535C57.6825 31.6225 58.75 32.7688 58.75 34.125C58.75 35.5688 57.5688 36.75 56.125 36.75ZM46.5 32.375H48.7312V35H51.2688V32.375H53.5L50 28.875L46.5 32.375Z",
    fill: "black"
  }))), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 26,
    width: 31,
    height: 31,
    rx: 15.5,
    fill: "white"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 26,
    width: 31,
    height: 31,
    rx: 15.5,
    stroke: "#E9E9E9"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_5198_35307)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.3334 34.8333H12.0001C11.2667 34.8333 10.6734 35.4333 10.6734 36.1667L10.6667 46.8333C10.6667 47.5667 11.2601 48.1667 11.9934 48.1667H20.0001C20.7334 48.1667 21.3334 47.5667 21.3334 46.8333V38.8333L17.3334 34.8333ZM12.0001 46.8333V36.1667H16.6667V39.5H20.0001V46.8333H12.0001Z",
    fill: "black"
  }))), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 66.5,
    y: 26,
    width: 31,
    height: 31,
    rx: 15.5,
    fill: "white"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 66.5,
    y: 26,
    width: 31,
    height: 31,
    rx: 15.5,
    stroke: "#E9E9E9"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_5198_35307)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M80.1133 37.5L81.4466 38.8333H87.3333V45.5H76.6666V37.5H80.1133ZM80.6666 36.1667H76.6666C75.9333 36.1667 75.3399 36.7667 75.3399 37.5L75.3333 45.5C75.3333 46.2333 75.9333 46.8333 76.6666 46.8333H87.3333C88.0666 46.8333 88.6666 46.2333 88.6666 45.5V38.8333C88.6666 38.1 88.0666 37.5 87.3333 37.5H81.9999L80.6666 36.1667Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5198_35307"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 21,
    height: 21,
    fill: "white",
    transform: "translate(39.5 21)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_5198_35307"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(8 33.5)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_5198_35307"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(74 33.5)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadPlaceholder);
export default __webpack_public_path__ + "static/media/upload-placeholder.f404aee7aa712a37ebf0475e956cb0d0.svg";
export { ForwardRef as ReactComponent };